import { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { fundingPaths } from "../../routes/funding";
import { contactUs } from "../../redux/features/coach/actions/authAction";
import ProjectSuccessModal from "../../components/Modals/common/ProjectSuccessModal";
import { curSym } from "../../utils/pip";

const FundingSubmitProject = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const navigate = useNavigate();
  const [isProSubModal, setIsProSubModal] = useState(false);
  //   const [navBarDemo, setNavBarDemo] = useState("Founder");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <section
            class="ct_px_40 mt-4   ct_dark_sky_bg py-5"
            style={{ backgroundColor: "#219EBC" }}
          >
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-7 col-xl-7 col-md-8 mb-4 mb-md-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_px_40 ct_px_0_767">
                    <h2
                      class="ct_fs_50_new mb-4 text-white"
                      style={{ maxWidth: "661px" }}
                    >
                      Let’s Bring Your{" "}
                      <span className="ct_darkblue_text">Vision</span> To Life
                    </h2>
                    <p
                      class="mb-0 mt-3 ct_fs_20 text-white "
                      style={{ maxWidth: "648px" }}
                    >
                      Ready to launch your next big idea? Share the details and
                      let our experts help you execute it with clarity and
                      precision.
                    </p>
                    <div class="ct_mt_40">
                      <a
                        class="ct_yellow_btn ct_darkblue_btn  px-5 ct_fit_content ct_h_48"
                        onClick={() => navigate(fundingPaths.ExploreProject)}
                      >
                        View Project
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xxl-5 col-xl-5 col-md-4 mb-4 mb-md-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_boocamp_img_left ct_boocamp_img_left_991">
                    <img
                      src="../assets/img/funding_submit_right_banner_img.png"
                      alt=""
                      class="ct_img_h_458 w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 ct_py_130">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img">
                    <img
                      src="../assets/img/explore_project_how_works_left_img.png"
                      alt=""
                      style={{ objectFit: "cover", objectPosition: "right" }}
                    />
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_24_new ct_dakrblue_text">How It Works?</h4>
                    <h3 class="ct_fs_32 ct_dakrblue_text ">
                      From Idea to Action
                    </h3>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/Apply_icon_1.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            {/* onClick={() => navigate(fundingPaths.SubmitProject)} */}
                            Submit Your Project
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "249px" }}
                          >
                            Tell us your or challenge in a few simple details.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/Apply_icon_2.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            We Review and Respond
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            Our team reviews it and gets back to you within 48
                            hours.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/Apply_icon_3.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Start with Confidence
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            Receive guidance and begin your project with
                            clarity.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className=" ct_px_40 ct_pb_100  ">
            <div className="container-fluid">
              <div className="row">
                <div
                  className="col-xxl-7 col-xl-7 col-lg-7 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <h4 className="ct_fs_32 mb-3 ct_orange_text">
                    Tell Us About Your Project
                  </h4>
                  <p className="ct_fs_20" style={{ maxWidth: "691px" }}>
                    Give us the key detail so we can understand your vision,
                    goals, and where you need support. The more you share, the
                    better we can tailor our response.
                  </p>

                  <form class="ct_mt_60">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Full Name
                          </label>
                          <input
                            type="text"
                            placeholder="e.g "
                            class="form-control ct_input ct_input_h_60 ct_fs_14"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Email Address
                          </label>
                          <input
                            type="email"
                            placeholder=" Email address "
                            class="form-control ct_input ct_input_h_60 ct_fs_14"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Phone Number
                          </label>
                          <input
                            type="number"
                            placeholder=" Phone number "
                            class="form-control ct_input ct_input_h_60 ct_fs_14"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label class="d-block mb-2 ct_fs_14">
                            Business Name
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                              <option>Business Name </option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                          <p className="mb-0 ct_darkblue_text mt-2 ct_text_op_7">
                            Leave this blank if is not necessary
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Website/ Organization Name
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                              <option>eg. Nuvio</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Project Title
                          </label>

                          <input
                            type="text"
                            placeholder=" Project title"
                            class="form-control ct_input ct_input_h_60 ct_fs_14"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Type of Project
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                              <option>eg. Education </option>
                              <option>eg. Education</option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Project Summary
                          </label>
                          <textarea
                            class="form-control ct_input h-auto ct_fs_14"
                            rows="5"
                            placeholder="Type project summary"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Project Stage
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                              <option>Select </option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Minimum Educational Qualification
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                              <option>Select </option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Project Goals
                          </label>
                          <input
                            type="text"
                            placeholder="Project goals"
                            class="form-control ct_input ct_input_h_60 ct_fs_14"
                          />
                          <p className="mb-0 ct_text_op_7 mt-2">
                            Input the primary goal of this project
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Timeline
                          </label>
                          <div className="d-flex flex-column gap-2 position-relative">
                            <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                              <option>e.g 5000 </option>
                            </select>
                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-4">
                          <label for="" class="d-block mb-2 ct_fs_14">
                            Budget
                          </label>

                          <input
                            type="text"
                            placeholder={curSym}
                            class="form-control ct_input ct_input_h_60 ct_fs_14"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label for="" class="d-block mb-2 ct_fs_14">
                          Upload Project
                        </label>
                        <div
                          class="ct_upload_product_main ct_upload_product_main_180 "
                          style={{ height: "142px" }}
                        >
                          <label>
                            <p class="text-center ct_fs_18 ct_text_op_07 mb-0 ct_cursor_pointer">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11 9.00025V15.0002C11.0003 15.2551 11.0979 15.5003 11.2728 15.6856C11.4478 15.871 11.687 15.9825 11.9414 15.9974C12.1958 16.0124 12.4464 15.9296 12.6418 15.766C12.8373 15.6024 12.9629 15.3703 12.993 15.1172L13 15.0002V9.00025H19C19.5046 9.00009 19.9906 9.19066 20.3605 9.53375C20.7305 9.87684 20.9572 10.3471 20.995 10.8502L21 11.0002V20.0002C21.0002 20.5048 20.8096 20.9908 20.4665 21.3608C20.1234 21.7308 19.6532 21.9574 19.15 21.9953L19 22.0002H5C4.49542 22.0004 4.00943 21.8098 3.63945 21.4668C3.26947 21.1237 3.04284 20.6534 3.005 20.1502L3 20.0002V11.0002C2.99984 10.4957 3.19041 10.0097 3.5335 9.6397C3.87659 9.26972 4.34684 9.04309 4.85 9.00525L5 9.00025H11ZM12.884 2.46925L16.243 5.82725C16.4306 6.01489 16.5361 6.26938 16.5361 6.53475C16.5361 6.80011 16.4306 7.05461 16.243 7.24225C16.0554 7.42989 15.8009 7.53531 15.5355 7.53531C15.2701 7.53531 15.0156 7.42989 14.828 7.24225L13 5.41325V9.00025H11V5.41325L9.172 7.24225C9.07909 7.33516 8.96879 7.40886 8.8474 7.45914C8.726 7.50942 8.5959 7.53531 8.4645 7.53531C8.33311 7.53531 8.203 7.50942 8.0816 7.45914C7.96021 7.40886 7.84991 7.33516 7.757 7.24225C7.66409 7.14934 7.59039 7.03904 7.54011 6.91764C7.48982 6.79625 7.46394 6.66614 7.46394 6.53475C7.46394 6.40335 7.48982 6.27325 7.54011 6.15185C7.59039 6.03046 7.66409 5.92016 7.757 5.82725L11.117 2.46925C11.3514 2.23506 11.6692 2.10352 12.0005 2.10352C12.3318 2.10352 12.6496 2.23506 12.884 2.46925Z"
                                  fill="#023047"
                                ></path>
                              </svg>
                              Upload Photo
                            </p>

                            <input type="file" class="d-none" />
                          </label>
                        </div>

                        <div
                          class="ct_single_uploaded_img mt-3 d-none "
                          style={{ height: "135px" }}
                        >
                          <img
                            src="../assets/img/workshop_overlay_img_1.png"
                            alt=""
                            className="w-100 h-100"
                            style={{ borderRadius: "0px" }}
                          />
                          <i class="fa-solid fa-xmark"></i>
                        </div>
                      </div>
                    </div>
                    <div className="row ct_mt_60 gap-5">
                      <div className="col-md-12">
                        <h4 className="ct_fs_30 ct_darkblue_text ct_mb_20">
                          Submit & Confirmation
                        </h4>
                        <p
                          className="mb-0 ct_fs_18 ct_darkblue_text"
                          onClick={openSignUp}
                        >
                          Thanks for sharing your project with us! Our team will
                          review the details and get back to you within{" "}
                          <span className="ct_darksky_blue_text">48 hours</span>
                          .
                        </p>
                      </div>
                    </div>

                    <div className="text-end mt-5">
                      <button
                        type="button"
                        class="ct_yellow_btn  px-5 ms-auto"
                        onClick={() => {
                          setIsProSubModal(true);
                        }}
                      >
                        {" "}
                        Submit Project For Review
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  className="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0 ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="ct_need_help_card ct_mt_100">
                    <h4 className="ct_fs_24_new ct_mb_20">
                      Need Help Filling This Form?
                    </h4>
                    <ul>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        Use a clear, specific job title that reflects the role
                        and level skip vague or trendy terms.
                      </li>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        Describe what makes the role exciting or unique to help
                        your post stand out.
                      </li>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        List the main responsibilities, skills required, and
                        what success looks like.
                      </li>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        Specify if the job is remote, hybrid, or onsite to
                        manage expectations from the start.
                      </li>
                    </ul>
                    <p className="ct_fs_18 mt-4">
                      Need help{" "}
                      <span
                        className="ct_yellow_text ct_cursor_pointer"
                        onClick={() =>
                          navigate(coachPaths.ContactUs, {
                            state: { data: "landing" },
                          })
                        }
                      >
                        Contact Us
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg      ct_p_111_y_106 ct_mt_100"
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Still Have Questions?</h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "700px" }}
                >
                  We’re here to help you every step of the way. Reach out
                  anytime for personalized support.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() =>
                    navigate(coachPaths.ContactUs, {
                      state: { data: "landing" },
                    })
                  }
                >
                  Talk to Us
                </a>
              </div>
            </div>
          </section>

          <section
            class="  ct_px_40   ct_mt_130"
            style={{ backgroundColor: "#F5F3EF", paddingBlock: "72px" }}
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-lg-4 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="d-grid h-100 pt-2 pb-5">
                    <h2
                      class="ct_fs_40 ct_darkblue_text"
                      style={{ maxWidth: "300px" }}
                    >
                      Real Stories, real{" "}
                      <span class="ct_yellow_text">success</span>
                    </h2>
                    <div className="ct_arrows mt-auto">
                      <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                      <button className="ct_next ct_arrow_btn" ref={nextRef}>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 2500 }}
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    className="ct_real_stories_slider"
                  >
                    {/* Slide 1 */}
                    {[1, 2, 3, 4, 5]?.map((item, index) => (
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="../assets/img/real_succss_img_457.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Climbing Higher with Every Project
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              NuStar gave me access to exclusive projects that
                              truly challenged and grew my expertise. Today, I
                              lead innovative product initiatives and mentor
                              upcoming tech talents
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Chloe Adams
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Product Director at Zenith Tech
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </section>

          <section class=" ct_px_40  ct_py_130 pb-0 ">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_img">
                    <img
                      src="../assets/img/funding_submit_faq_left.png"
                      class="ct_img_h_617"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 ps-md-5 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_cnt">
                    <h2 class=" ct_fs_32  ct_mb_60">
                      Frequently asked questions
                    </h2>

                    <div class="ct_faq_question_main ">
                      <div class="accordion" id="faq_accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faq_one">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_one"
                              aria-expanded="false"
                              aria-controls="collapsefaq_one"
                            >
                              How do I get started as a freelancer on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_one"
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqtwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Two"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              What types of projects can I find on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Two"
                            class="accordion-collapse collapse "
                            aria-labelledby="faqtwo"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqthree">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Three"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Three"
                            >
                              How does payment work?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Three"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqthree"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqFour">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Four"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Four"
                            >
                              What support does NUVIO provide to freelancers?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Four"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqFour"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-left"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left  ct_mt_100"
            style={{
              paddingTop: "134px",
              paddingBottom: "157px",
              backgroundColor: "#8ECAE6",
            }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Still Have Questions?</h4>
                <p class="mb-0 ct_fs_18 ct_fw_300">
                  We’re here to help you every step of the way. Reach out
                  anytime for personalized support.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() =>
                    navigate(coachPaths.ContactUs, {
                      state: { data: "landing" },
                    })
                  }
                >
                  Contact Us
                </a>
              </div>
            </div>
          </section>

          {isProSubModal && (
            <ProjectSuccessModal
              onClose={() => {
                setIsProSubModal(false);
              }}
            />
          )}

          <div style={{ height: "100px" }}></div>
        </>
      )}
    </MenuLayout>
  );
};
export default FundingSubmitProject;
